import { getModuleName } from '../config';
const routes = [
    {
        path: '/index/:id',
        name: 'questions',
        component: () => import('@/views/littleGameGroup/questions/index.vue')
    },
]

export default getModuleName('questions', routes);